// @flow
import React, { PureComponent } from 'react';
import type { FullUserType } from 'types/User';
import { handleTagEvent } from 'utils/tagManagerUtils';
import { getPublicAssets } from 'utils/assetsUtils';

export type StateProps = {
  boutique: {
    link: string,
    title: string,
    image: string,
    description: string,
    cta: string,
    banner_only: boolean,
  },
  userPref: FullUserType
};

type Props = StateProps;

class CardBoutique extends PureComponent<Props> {
  render() {
    const {
      boutique: {
        link,
        title,
        image,
        description,
        cta,
        banner_only
      },
      userPref
    } = this.props;
    if (banner_only && image) {
      return (
        <div className="col">
            <a
              href={link ? link : "https://boutique.ffr.fr/"}
              onClick={handleTagEvent(
                'module_ecosysteme',
                link ? link : 'https://boutique.ffr.fr/',
                '',
                userPref
              )}
              title={title ? title : 'Boutique officielle FFR'}
              target="__blank"
              rel="noopener noreferrer"
              className="box card--hub-alt">
                <img src={ image ? image : getPublicAssets('/img/banner/official-store.jpg') } alt="" />
          </a>
        </div>
      );
    }
    return (
      <div className="col">
          <a
            href={link ? link : "https://boutique.ffr.fr/"}
            onClick={handleTagEvent(
              'module_ecosysteme',
              link ? link : 'https://boutique.ffr.fr/',
              '',
              userPref
            )}
            title={title ? title : 'Boutique officielle FFR'}
            target="__blank"
            rel="noopener noreferrer"
            className="box card card--hub-alt card--small card--xSmall">
            <div
              className="card__thumbnail img-blue-dark"
              style={{ backgroundImage: `url(${image ? image : getPublicAssets('/img/banner/official-store.jpg')})` }}>
              <img src={ image ? image : getPublicAssets('/img/banner/official-store.jpg') } alt="" />
            </div>
            <div className="card__body">
              <h3 className="card__title">{title ? title : 'Boutique officielle FFR'}</h3>
              <p className="card__desc ft-secondary">
                {description ? description : 'Retrouvez tous les articles, maillots, ballons officiels de l’équipe.'}
              </p>
            </div>
          <div className="card__footer">
            <span className="btn btn--cheer">
              <i className="icon icon-chevron-right link-icon is-dark is-inline"></i>
              <span>{cta ? cta : 'Découvrir la collection'}</span>
            </span>
          </div>
        </a>
      </div>
    );
  }
};

export default CardBoutique;
